// src/features/landing/presentation/components/MarketProblemsSection.jsx
import React from "react";

export function MarketProblemsSection() {
    const problems = [
        {
            id: 1,
            icon: "🔊",
            title: "필요한 시기에 채용하기 어렵습니다",
            description:
                "지인 소개에 기대다 보니 원하는 시기에 사람을 구하기 어렵고, 급하게 뽑으면 회사와 GA 매니저·총무·스태프 모두 만족하기 어렵습니다.",
        },
        {
            id: 2,
            icon: "👥",
            title: "소개비 부담이 큽니다",
            description:
                "보험시장 경쟁이 심해지면서 소개비와 채용 프로모션 비용은 늘었지만, 들인 비용만큼 효과를 보기 어렵습니다.",
        },
        {
            id: 3,
            icon: "📋",
            title: "인재풀이 한정적입니다",
            description:
                "전문 채용 채널이 없어 아는 사람 안에서만 후보를 찾게 되고, 회사가 원하는 조건에 맞는 인재를 고르기 어렵습니다.",
        },
        {
            id: 4,
            icon: "🚫",
            title: "역량을 검증할 방법이 없습니다",
            description:
                "GA 매니저·총무·스태프의 실무 능력과 고객 응대 역량을 확인할 기준이 없어, 입사 후 조기 이탈로 이어지기도 합니다.",
        },
        {
            id: 5,
            icon: "😰",
            title: "영업관리자가 채용에 지칩니다",
            description:
                "채용 부담이 현장 관리자에게 몰리면서 영업·마케팅 같은 본업에 집중하기 어렵습니다.",
        },
    ];

    return (
        <section className="market-problems-section">
            <div className="problems-container">
                <h2 className="problems-title">
                    <span className="title-highlight">GA 전문 인력 채용 시장,</span>
                    <br />
                    무엇이 문제인가요?
                </h2>

                <div className="problems-wrapper">
                    <div className="problems-row problems-row-top">
                        <div className="problem-card">
                            <div className="problem-icon">{problems[0].icon}</div>
                            <h3 className="problem-title">{problems[0].title}</h3>
                            <p className="problem-description">{problems[0].description}</p>
                        </div>
                        <div className="problem-card">
                            <div className="problem-icon">{problems[1].icon}</div>
                            <h3 className="problem-title">{problems[1].title}</h3>
                            <p className="problem-description">{problems[1].description}</p>
                        </div>
                    </div>

                    <div className="problems-row problems-row-middle">
                        <div className="problem-card">
                            <div className="problem-icon">{problems[2].icon}</div>
                            <h3 className="problem-title">{problems[2].title}</h3>
                            <p className="problem-description">{problems[2].description}</p>
                        </div>
                    </div>

                    <div className="problems-row problems-row-bottom">
                        <div className="problem-card">
                            <div className="problem-icon">{problems[3].icon}</div>
                            <h3 className="problem-title">{problems[3].title}</h3>
                            <p className="problem-description">{problems[3].description}</p>
                        </div>
                        <div className="problem-card">
                            <div className="problem-icon">{problems[4].icon}</div>
                            <h3 className="problem-title">{problems[4].title}</h3>
                            <p className="problem-description">{problems[4].description}</p>
                        </div>
                    </div>
                </div>

                <div className="problems-conclusion">
                    <p className="conclusion-text">
                        보험업계를 제대로 아는,{" "}
                        <span className="conclusion-highlight">
                            GA매니저/총무/스태프 전문 헤드헌터
                        </span>
                        가 시장에 절실합니다.
                    </p>
                </div>
            </div>

            <style jsx>{`
                .market-problems-section {
                    width: 100%;
                    min-height: 100vh;
                    background: linear-gradient(135deg, #2a4a6f 0%, #1e3556 100%);
                    padding: 80px 40px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .problems-container {
                    max-width: 1400px;
                    width: 100%;
                }

                .problems-title {
                    font-size: 3rem;
                    font-weight: 800;
                    color: white;
                    text-align: left;
                    margin-bottom: 80px;
                    line-height: 1.3;
                }

                .title-highlight {
                    color: #ff6342;
                }

                .problems-wrapper {
                    display: flex;
                    flex-direction: column;
                    gap: 40px;
                    margin-bottom: 100px;
                }

                .problems-row {
                    display: flex;
                    gap: 40px;
                    align-items: center;
                }

                .problems-row-top,
                .problems-row-bottom {
                    justify-content: space-between;
                }

                .problems-row-middle {
                    justify-content: center;
                    gap: 60px;
                }

                .problem-card {
                    background: white;
                    border-radius: 24px;
                    padding: 32px;
                    box-shadow: 0 12px 48px rgba(0, 0, 0, 0.3);
                    display: flex;
                    flex-direction: column;
                    gap: 16px;
                    flex: 1;
                    max-width: 600px;
                    transition: transform 0.3s ease, box-shadow 0.3s ease;
                }

                .problem-card:hover {
                    transform: translateY(-8px);
                    box-shadow: 0 16px 56px rgba(0, 0, 0, 0.4);
                }

                .problem-icon {
                    font-size: 3rem;
                    line-height: 1;
                    margin-bottom: 8px;
                }

                .problem-title {
                    font-size: 1.3rem;
                    font-weight: 700;
                    color: #1e3556;
                    margin: 0;
                    line-height: 1.4;
                }

                .problem-description {
                    font-size: 1.05rem;
                    color: #5a6c84;
                    line-height: 1.7;
                    margin: 0;
                }

                .problems-conclusion {
                    text-align: center;
                    padding: 40px 20px;
                }

                .conclusion-text {
                    font-size: 2rem;
                    color: white;
                    font-weight: 600;
                    line-height: 1.6;
                    margin: 0;
                }

                .conclusion-highlight {
                    background: white;
                    color: #1e3556;
                    padding: 6px 20px;
                    border-radius: 10px;
                    font-weight: 800;
                    box-shadow: 0 4px 16px rgba(255, 255, 255, 0.3);
                }

                @media (max-width: 1200px) {
                    .problems-title {
                        font-size: 2.4rem;
                    }

                    .problem-card {
                        padding: 28px;
                    }

                    .problem-title {
                        font-size: 1.2rem;
                    }

                    .problem-description {
                        font-size: 1rem;
                    }
                }

                @media (max-width: 768px) {
                    .market-problems-section {
                        padding: 60px 20px;
                    }

                    .problems-title {
                        font-size: 1.8rem;
                        margin-bottom: 50px;
                    }

                    .problems-wrapper {
                        gap: 30px;
                        margin-bottom: 60px;
                    }

                    .problems-row {
                        flex-direction: column;
                        gap: 30px;
                    }

                    .problems-row-middle {
                        gap: 30px;
                    }

                    .problem-card {
                        max-width: 100%;
                        padding: 24px;
                    }

                    .problem-icon {
                        font-size: 2.5rem;
                    }

                    .problem-title {
                        font-size: 1.1rem;
                    }

                    .problem-description {
                        font-size: 0.95rem;
                    }

                    .conclusion-text {
                        font-size: 1.4rem;
                    }

                    .conclusion-highlight {
                        display: inline-block;
                        margin-top: 8px;
                    }
                }
            `}</style>
        </section>
    );
}
